"use strict";
import DrawingUtils from "../../util/drawing_utils";
import Circle from "./circle";
import CONSTANTS from "./constants";
import theme from "./theme";
const { DRAG_POINT_RADIUS } = CONSTANTS;
const { distance, PropTypes } = DrawingUtils;
const DragPoint = ({ hovered, position }) => {
  return /* @__PURE__ */ React.createElement(
    Circle,
    {
      position: {
        center: position,
        radius: DRAG_POINT_RADIUS
      },
      lineWidth: hovered ? 2 : 0,
      lineColor: theme.COLORS.base,
      fillColor: theme.COLORS.transBase
    }
  );
};
DragPoint.propTypes = {
  position: PropTypes.Vector.isRequired,
  hovered: React.PropTypes.bool
};
DragPoint.isPointIn = (point) => (connectorPos) => {
  return distance(point, connectorPos).length() < DRAG_POINT_RADIUS;
};
export default DragPoint;
